var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 7,
    viewBox: "0 0 27 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23891",
    "data-name": "Grupo 23891",
    transform: "translate(-262 -226)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_573",
    "data-name": "Elipse 573",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(282 226)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_572",
    "data-name": "Elipse 572",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(272 226)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_571",
    "data-name": "Elipse 571",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(262 226)",
    fill: "#d5d5d5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoOptions);
export default __webpack_public_path__ + "static/media/icono-options.3cf0cecb4cb1230acef2af83e50378c9.svg";
export { ForwardRef as ReactComponent };